import React from 'react'
import styled, { css } from 'styled-components'
import { sanitizeHTML } from '../../../helpers/utils'

const v4 = css`
  background-color: #fff;
  border-color: #d8dada;

  .name {
    color: var(--black);
    text-decoration: none;
  }
  @media (max-width: 991px) {
    width: 92%;
    height: 76px;
    flex-direction: row;
  }
`

const Wrapper = styled.a`
  width: 242px;
  height: 76px;
  background: #f5f9fc;
  border: 1px solid var(--clr-tf-main);
  border-radius: 5px;
  display: flex;
  padding: 10px 60px 10px 20px;

  .icon {
    width: var(--icon-width, 58px);
  }
  .name {
    width: calc(100% - 30px);
    padding: 8px 0px 8px 20px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--clr-tf-main);
  }

  @media (max-width: 991px) {
    width: 110px;
    height: 150px;
    flex-direction: column;
    padding: 20px 10px;
    align-items: center;

    .icon {
      width: unset;
    }

    .name {
      width: unset;
      padding: 15px 5px 10px;
      text-align: center;
    }
  }
  ${props => props.version === 'v4' && v4}
`

function createMarkup(html) {
  return { __html: sanitizeHTML(html) }
}

const GenericLink = ({ icon, name, path, version }) => {
  return (
    <Wrapper href={path} version={version}>
      <div className="icon">
        <img src={icon} alt="" />
      </div>
      <div dangerouslySetInnerHTML={createMarkup(name)} className="name" />
    </Wrapper>
  )
}

export default GenericLink



// WEBPACK FOOTER //
// ./src/components/Navbar/components/GenericLink.js